import { logHelper } from '@wegic/utils';

/**
 * 判断是否为浏览器环境
 */
export function isBrowser(): boolean {
  return typeof window !== 'undefined';
}

export function logDebug(message: string, data?: any): void {
  if (process.env.NODE_ENV === 'development') {
    logHelper.log(`[Analytics] ${message}`, data || '');
  }
}
